window.addEventListener('load', function () {
    if (document.querySelectorAll('.product').length) {
        const elements = document.querySelectorAll('.product');
        const mq = window.matchMedia('(max-width: 1023px)');

        elements.forEach(function (element) {

            let productSlider = new Swiper(element.querySelector('.swiper'), {
                watchOverflow: true,
                lazy: true,
                preloadImages: false,
                loadPrevNext: true,
                checkInView: true,
                slidesPerView: 1,
                spaceBetween: 0,
                enabled: true,
                breakpoints: {
                    320: { slidesPerView: 1, spaceBetween: 20 },
                    600: { slidesPerView: 1, spaceBetween: 0 },
                    660: { slidesPerView: 1, spaceBetween: 0 },
                    900: { slidesPerView: 1, spaceBetween: 0 },
                    1024: { slidesPerView: 1, spaceBetween: 1 },
                },
                pagination: {
                    el: element.querySelector('.swiper-pagination'),
                    clickable: "true",
                },
                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                }
            });

            const iconEl = element.querySelector('.icon.swiper');
            let iconSlider = null;

            function initIconSlider() {
                if (iconEl && !iconSlider) {
                    iconSlider = new Swiper(iconEl, {
                        loop: true,
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        freeMode: true,
                        freeModeMomentum: false,
                        allowTouchMove: false,
                        speed: 6000,
                        autoplay: {
                            delay: 1,
                            disableOnInteraction: false,
                        },
                        watchOverflow: true,
                    });
                }
            }

            function destroyIconSlider() {
                if (iconSlider) {
                    iconSlider.destroy(true, true);
                    iconSlider = null;
                }
            }

            function handleMqChange(e) {
                if (e.matches) {
                    initIconSlider();
                } else {
                    destroyIconSlider();
                }
            }

            if (iconEl) {
                handleMqChange(mq);
                mq.addEventListener('change', handleMqChange);
            }
        });
    }
});
